import React, { Component } from 'react';

import LogoutContainer from '../../routes/Logout/containers/LogoutContainer';

const AuthHOC = (Comp) => {
  class ProtectedComponent extends Component {
    render() {
      return localStorage.getItem('axsBearerToken') !== null ? (
        <Comp {...this.props} />
      ) : (
        <LogoutContainer />
      );
    }
  }

  return ProtectedComponent;
};

export default AuthHOC;



// WEBPACK FOOTER //
// ./src/common/HOC/AuthHOC.js